// Danh sách các ngôn ngữ, sẽ lấy resource từ folder tương ứng
const locales = ['vi', 'en']

// Modules
const localeModules = require.context(
  './',
  true,
  /[A-Za-z0-9-_,\s]+\.(js)$/i
)

function mapModules (context) {
  const keys = context.keys()
  const values = keys.map(context)
  const result = locales.reduce((res, locale) => {
    res[locale] = {}
    return res
  }, {})

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    const localeMatched = key.match(/.\/([A-Za-z]+)\//i)

    if (matched?.length > 1 && localeMatched?.length > 1) {
      const locale = localeMatched[1]
      const moduleName = matched[1]
      const module = values[i].default

      if (module && result[locale]) {
        result[locale][moduleName] = module
      }
    }
  }
  return result
}
const i18nData = mapModules(localeModules)

export default i18nData
